<template>
  <div class="container-fluid">
    <b-row>
      <b-col sm="6" id="watch-container">
        <WatchComponentsContainer />
      </b-col>
      <b-col class="text-left" sm="6">
        <ConfiguratorContainer/>
        <div id="action-buttons">
          <ShareComponent id="share-component"/>
          <DownloadComponent id="download-component" />
          <ContactComponent id="contact-component" />
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col class="text-left">
        <!--<p class="paragraph">{{$t('configurator.taxes')}}</p> -->
        <p class="text-justify paragraph">{{$t('configurator.disclaimer')}}</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import ConfiguratorContainer from '@/components/ConfiguratorContainer.vue';
import WatchComponentsContainer from '@/components/WatchComponentsContainer.vue';
import ShareComponent from '@/components/share/ShareComponent'
import DownloadComponent from '@/components/download/DownloadComponent'
import ContactComponent from '@/components/ContactComponent.vue'
import store from '@/store'
import {ShareLinkBuilderService} from '../components/share/ShareLinkBuilder'

export default {
  name: 'Home',
  components: {
    ConfiguratorContainer,
    WatchComponentsContainer,
    ShareComponent,
    ContactComponent,
    DownloadComponent
  },
  store,
  created() {
      if (this.$route.query.s) {
          const existing = ShareLinkBuilderService.extractFromLink(this.$route.query.s)
          this.$store.commit('setColors', existing)
      }
  }
};
</script>

<style scoped>
#action-buttons {
  text-align:left;
}
#share-component, #download-component, #contact-component {
    display: inline-block;
    margin-right: 3vw;
}

#contact-component  {
  position: relative;
  top: -10px;
}

#watch-container {
  margin-top: -50px;
}
</style>
